import React, { useState, useEffect } from 'react';
import App from '../App';
import Loader from './Loader';

const overlayStyle = {
  position: 'fixed',
  inset: 0,
  zIndex: 9999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: '#ffffff',
};

/**
 * Full reload / hard refresh par pehle Loader, phir App mount
 * (window load + bfcache restore handle).
 */
function AppWithPageLoadLoader() {
  const [pageReady, setPageReady] = useState(false);

  useEffect(() => {
    const markReady = () => setPageReady(true);

    if (document.readyState === 'complete') {
      const id = requestAnimationFrame(markReady);
      return () => cancelAnimationFrame(id);
    }

    window.addEventListener('load', markReady, { once: true });
    return () => window.removeEventListener('load', markReady);
  }, []);

  useEffect(() => {
    const onPageShow = (e) => {
      if (e.persisted) setPageReady(true);
    };
    window.addEventListener('pageshow', onPageShow);
    return () => window.removeEventListener('pageshow', onPageShow);
  }, []);

  if (!pageReady) {
    return (
      <div style={overlayStyle} aria-busy="true" aria-live="polite">
        <Loader size="large" text="Loading application..." showText />
      </div>
    );
  }

  return <App />;
}

export default AppWithPageLoadLoader;
